// ABOUTME: Filters metadata fields that a form deliberately omits from its UI.
// ABOUTME: Keeps hidden fields out of generated validation and rendered groups.

export const filterHiddenFormMetadata = <T extends { fieldName?: string }>(
    metadata: readonly T[],
    fieldsToHide: readonly string[] = []
) => {
    if (!fieldsToHide.length) return [...metadata];

    const hiddenFields = new Set(fieldsToHide);
    return metadata.filter((field) => !hiddenFields.has(field.fieldName || ""));
};
